import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store';
import moment from "moment-jalaali"; // path to vuetify export
import vuetify from '@/plugins/vuetify' // path to vuetify export
import { fn } from '@/assets/js/fn';
import VuePersianDatetimePicker from 'vue-persian-datetime-picker';


router.beforeEach((to, from, next) => {
    // store.state.loading = true;

    if (store.state.userId > 0) {
        // if (!(store.state.adminRole>0) && store.state.adminRoutes.includes(to.name)) {
        //     next('/');
        //     store.state.loading = false;
        // } else {
        // }

        if (to.path === '/add') {
            router.push('/')
        }else {
            next();
        }
    } else {
        if (to.path === '/add') {
            next();
        } else {
            router.push('/add')
        }
    }
});


router.afterEach(() => {
    store.state.loading = false;
});
Vue.prototype.$fn = fn;


Vue.filter('digit', function (number) {
    return Number(Math.round(number)).toLocaleString();

});

Vue.filter('momentDate', function (date) {
    return moment.unix(date).locale('fa').format('jYYYY/jMM/jDD');
});
Vue.filter('momentDay', function (date) {
    return moment.unix(date).locale('fa').format('dddd');
});
Vue.filter('dateEn', function (date) {
    let newdate= new Date(date*1000);
    newdate= newdate.toISOString();
    return newdate;
});


new Vue({
    router,
    store,
    vuetify,
    'date-picker': VuePersianDatetimePicker,
    render: h => h(App),
}).$mount('#app');
